import { createTelemetry, createTelemetryObject } from '@shared/core/analytics/telemetry';
import type { PagePrefix } from '@shared/core';
import { Answers } from './Survey.types';

const action = 'SurveyButtonInteracted';

const telemObject = createTelemetryObject({
  pages: {
    surveyPageViewed: (surveyName: string, stepName: string, answers: Answers, category: string, pagePrefix: PagePrefix) => ({
      action: 'SurveyPageViewed',
      category,
      pagePrefix,
      page: surveyName,
      extraPageInfo: {
        step: stepName,
      },
    }),
  },
  actions: {
    surveyNextStepClicked: (surveyName: string, stepName: string, nextStepName: string, answers: Answers, category: string, pagePrefix: PagePrefix) => ({
      action,
      category,
      pagePrefix,
      extraInfo: {
        name: 'surveyNextStepClicked',
        surveyInputReceived: {
          surveyName,
          stepName,
          nextStepName,
          answers,
        },
      },
    }),
    surveyCompleted: (surveyName: string, stepName: string, answers: Answers, category: string, pagePrefix: PagePrefix, surveySkipped: boolean = false) => ({
      action,
      category,
      pagePrefix,
      extraInfo: {
        name: 'surveyCompleted',
        surveySkipped,
        surveyInputReceived: {
          surveyName,
          stepName,
          answers,
        },
      },
    }),
  },
});

const { TelemetryProvider: SurveyTelemetryProvider, useTelemetry: useSurveyTelemetry } = createTelemetry(telemObject);

export { SurveyTelemetryProvider, useSurveyTelemetry };
